import { render, staticRenderFns } from "./SelectFormaColeta.vue?vue&type=template&id=b3d895fe&scoped=true&"
import script from "./SelectFormaColeta.vue?vue&type=script&lang=ts&"
export * from "./SelectFormaColeta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d895fe",
  null
  
)

export default component.exports